const nenotalReflexValues = ["normal", "abnorml"];

const systemicValues = [
  "Anaemia",
  "Vitamin D prophylaxis",
  "Jaundice",
  "Rickets",
];


const systemicValuesTwo = ["Rickets", "Anaemia"];

const responsiveCareGivingValuesA = [
  "Parental involvement with baby",
  "Makes eye contact",
  "Smiles/ talks/ sings",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesB = [
  "Actively interacts",
  "Engages with baby",
  "Reciprocates to the baby's cues",
  "Makes eye contact",
  "Smiles/ talks/ sings",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesC = [
  "Actively plays with baby",
  "Engages with baby",
  "Reciprocates to the baby's cues",
  "Makes eye contact",
  "Smiles/ talks/ sings",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesD = [
  "Actively plays: promotes joint attention",
  "Reciprocates to the baby's cues",
  "Promotes simple problem solving play",
  "Talks with baby",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesE = [
  "Actively plays: promotes joint attention",
  "Promotes simple problem solving play",
  "Sleep hygiene ok",
  "Limited screen time",
  "Both parents involved",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesF = [
  "Actively plays: promotes joint attention",
  "Promotes simple problem solving play",
  "Sleep hygiene ok",
  "Limited screen time",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesG = [
  "Actively plays: promotes joint attention",
  "Promotes simple problem solving play",
  "Sleep hygiene ok",
  "Limited screen time",
  "Inadequate",
  "None of the above",
]; // done -corrected

const responsiveCareGivingValuesH = [
  "Actively plays: promotes joint attention",
  "Promotes simple problem solving play",
  "Sleep hygiene ok",
  "Limited screen time",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesI = [
  "Actively plays: promotes joint attention",
  "Promotes simple problem solving play",
  "Sleep hygiene ok",
  "Limited screen time",
  "Inadequate",
  "None of the above",
]; //done

const responsiveCareGivingValuesJ = [
  "Actively plays with baby: promotes joint attention",
  "Responds to child’s questions",
  "Sleep hygiene",
  "Screen time",
  "Inadequate",
];

const earlyLearningOppertunityValuesA = [
  "Dangling toys",
  "Bright, colourful curtains, bed linen, wall hangings",
  "Singing/ talking to baby",
  "Massage, cuddling and holding baby",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesB = [
  "Dangling toys",
  "Rattles/ musical toys",
  "Bright, colourful curtains, bed linen, wall hangings",
  "Exposure to different textures",
  "Exposure to different sounds, words",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesC = [
  "Rattles/ musical toys",
  "Colourful, large objects of different shapes and textures to hold and handle",
  "Both parents play with baby",
  "Name objects while playing",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesD = [
  "Cause and effect toys",
  "Picture books",
  "Both parents play with baby",
  "Verbal communication while playing",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesE = [
  "Cause and effect toys",
  "Picture books",
  "Both parents play with baby",
  "Verbal communication while playing",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesF = [
  "Cause and effect toys",
  "Picture books",
  "Both parents play with baby",
  "Verbal communication while playing",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesG = [
  "Cause and effect toys",
  "Picture books",
  "Both parents play with baby",
  "Verbal communication while playing",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesH = [
  "Cause and effect toys",
  "Picture books",
  "Both parents play with baby",
  "Story telling",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesI = [
  "Problem solving and creative toys",
  "Picture books",
  "Both parents play with baby",
  "Story telling",
  "Inadequate",
  "None of the above",
]; //done

const earlyLearningOppertunityValuesJ = [
    "Attends preschool",
    "Problem solving and creative toys",
    "Reads books",
    "Encourages group play",
    "Story telling"
];

const anyRedFlagValuesA = [
  "Cannot suck/swallow",
  "Limbs stiff or limp",
  "Not looking at mother's face",
  "Not responding to sound"
];

const anyRedFlagValuesB = [
  "No social smile",
  "No head holding",
  "Doesn’t play with hands",
  "Doesn’t follow object",
  "No eye contact"
];

const anyRedFlagValuesC = [
  "No head holding",
  "Doesn’t play with hands",
  "Doesn’t follow object",
  "No eye contact",
  "Cannot roll over from back to tummy"
];

const anyRedFlagValuesD = [
  "Not reaching out for object",
  "Cannot sit without support",
  "Does not distinguish between known persons and strangers"
];

const anyRedFlagValuesE = [
  "Cannot sit up by himself"
];

const anyRedFlagValuesF = [
  "Cannot stand without support",
  "Immature grasp",
  "Poor object manipulation and play",
  "No babbling",
  "No gestures",
  "Cannot walk"
];

const anyRedFlagValuesG = [
  "Little interest in surroundings and caregivers",
  "Absence or minimal eye-contact or smiling"
];

const anyRedFlagValuesH = [
  "Excessive clumsiness/stumbling",
  "No '2-word' phrases",
  "No meaningful play with toys",
  "Poor response to commands"
];

const anyRedFlagValuesI = [
  "Prefers to play alone",
  "No imitation",
  "No pretend play",
  "Difficulty following simple instructions",
  "Cannot dress by own self",
  "Difficulty in learning new skills",
  "Slow in daily activities",
  "Poor recall",
  "Poor expressive language",
  "Behavioural problems"
];

const anyRedFlagValuesJ = [
  "No understandable speech",
  "Not able to follow simple commands",
  "Cannot walk up/down stairs",
  "No pretend/social play",
  "Does not interact with peers",
  "Excessive aggression or fearfulness",
  "Loss of previously acquired skills",
  "Poor eye contact",
  "Not responding when called",
  "Stereotypic/ repetitive behaviour",
  "Hyperactive/ impulsive"
]

const breastfeedingValues = [
  {
    value: "exclusive",
    label: "Exclusive",
  },
  {
    value: "occasional",
    label: "Occasional",
  },
  {
    value: "nil",
    label: "Nil",
  },
];

const babyProofingValues = [
  {
    value: "adequate",
    label: "Adequate",
  },
  {
    value: "inadequate",
    label: "Inadequate",
  },
];

const weightGainValues = [
  {
    value: "adequate",
    label: "Adequate",
  },
  {
    value: "inadequate",
    label: "Inadequate",
  },
  {
    value: "weight_loss",
    label: "Weight Loss",
  },
];

const feedingTeachniqueValues = [
  {
    value: "proper",
    label: "Proper",
  },
  {
    value: "faulty",
    label: "Faulty",
  },
];

const powerValues = ["4-5/5", "3/5", "<3/5"];

const reflexesValues = ["Normal", "Brisk", "Diminished (poor)"];

const visionValuesC = [
  "Follows objects",
  "Looks at face",
  "Follows light",
  "Follows finger",
];

const visionValuesD = [
  "Follows small objects",
  "Follows light",
  "Follows finger",
];

const visionValuesE = [
  "Follows small objects",
  "Follows light",
  "Follows finger",
];

const visionValuesF = [
  "Routine Eye Check done",
  "Follows light",
  "Follows finger",
];

const visionValuesG = [
  "Routine Eye Check done",
  "Follows light",
  "Follows finger",
];

const visionValuesH = [
  "Routine Eye Check done",
  "Follows light",
  "Follows finger",
];

const visionValuesI = [
  "Routine Eye Check done",
  "Follows light",
  "Follows finger",
];

const hearingValuesC = [
  "Responds to sound",
  "Listens to human voice",
  "Hearing Impaired",
];

const hearingValuesD = [
  "Responds to sound",
  "Listens to human voice",
  "Hearing Impaired",
];

const hearingValuesE = [
  "Responds to sound",
  "Listens to human voice",
  "Hearing Impaired",
];

const hearingValuesF = [
  "Responds to sound",
  "Listens to human voice",
  "Hearing Impaired",
];

const hearingValuesG = [
  "Responds when called",
  "Follows instructions",
  "Proper verbal response",
  "Hearing Impaired",
];

const hearingValuesH = [
  "Responds when called",
  "Follows instructions",
  "Proper verbal response",
  "Hearing Impaired",
];

const hearingValuesI = [
  "Responds when called",
  "Follows instructions",
  "Proper verbal response",
  "Hearing Impaired",
];

const nutritonValuesI = ["Diet adequate"];

const nutritonValuesE = ["Complimentary feeding adequate "];

const nutritonValuesC = [
  "Breastfeeding continuing",
  "Complimentary feeding started",
];

const nutritonValuesG = ["Diet adequate"];

const nutritonValuesH = ["Diet adequate"];

export {
  powerValues,
  reflexesValues,
  nenotalReflexValues,
  breastfeedingValues,
  weightGainValues,
  feedingTeachniqueValues,
  babyProofingValues,
  earlyLearningOppertunityValuesA,
  earlyLearningOppertunityValuesB,
  earlyLearningOppertunityValuesC,
  earlyLearningOppertunityValuesD,
  earlyLearningOppertunityValuesE,
  earlyLearningOppertunityValuesF,
  earlyLearningOppertunityValuesG,
  earlyLearningOppertunityValuesH,
  earlyLearningOppertunityValuesI,
  earlyLearningOppertunityValuesJ,
  responsiveCareGivingValuesA,
  responsiveCareGivingValuesB,
  responsiveCareGivingValuesC,
  responsiveCareGivingValuesD,
  responsiveCareGivingValuesE,
  responsiveCareGivingValuesF,
  responsiveCareGivingValuesG,
  responsiveCareGivingValuesH,
  responsiveCareGivingValuesI,
  responsiveCareGivingValuesJ,
  anyRedFlagValuesA,
  systemicValuesTwo,
  systemicValues,
  anyRedFlagValuesB,
  anyRedFlagValuesC,
  anyRedFlagValuesD,
  anyRedFlagValuesE,
  anyRedFlagValuesF,
  anyRedFlagValuesG,
  anyRedFlagValuesH,
  anyRedFlagValuesI,
  anyRedFlagValuesJ,
  visionValuesC,
  visionValuesD,
  visionValuesE,
  visionValuesF,
  visionValuesG,
  visionValuesH,
  visionValuesI,
  hearingValuesC,
  hearingValuesD,
  hearingValuesE,
  hearingValuesF,
  hearingValuesG,
  hearingValuesH,
  hearingValuesI,
  nutritonValuesI,
  nutritonValuesG,
  nutritonValuesE,
  nutritonValuesH,
  nutritonValuesC,
};